import { Checkbox, Spin } from "antd";
import React, { useState } from "react";

const options = [
    { label: "Online", value: "ONLINE", color: "#1890ff" },
    { label: "Live Online", value: "LIVE_ONLINE", color: "#9254de" },
    { label: "Offline", value: "OFFLINE", color: "#52c41a" },
    { label: "Cancel", value: "CANCEL", color: "#ff4d4f" },
    { label: "Holiday", value: "HOLIDAY", color: "#fa8c16" },
    { label: "Manual Schedule", value: "MANUAL", color: "" },
    { label: "Automatic Schedule", value: "AUTO", color: "" },
];

type FilterState = {
    modes: string[];
    arrange_types: string[];
    is_cancel?: boolean;
    show_holiday?: boolean;
};

const initialFilter: FilterState = {
    modes: [],
    arrange_types: [],
    is_cancel: undefined,
    show_holiday: undefined,
};

const modeValues = ["ONLINE", "LIVE_ONLINE", "OFFLINE"];
const arrangeTypeValues = ["AUTO", "MANUAL"];

const ScheduleFilter = ({ fetchGetSchedule, loading }: { fetchGetSchedule?: (params?: object) => void, loading: boolean | undefined }) => {
    const [filter, setFilter] = useState<FilterState>(initialFilter);
console.log(loading)
    const handleChange = (value: string) => {
        setFilter(prev => {
            if (modeValues.includes(value)) {
                const modes = prev.modes.includes(value)
                    ? prev.modes.filter(v => v !== value)
                    : [...prev.modes, value];
                return { ...prev, modes };
            }
            if (arrangeTypeValues.includes(value)) {
                const arrange_types = prev.arrange_types.includes(value)
                    ? prev.arrange_types.filter(v => v !== value)
                    : [...prev.arrange_types, value];
                return { ...prev, arrange_types };
            }
            if (value === "CANCEL") {
                return { ...prev, is_cancel: prev.is_cancel ? undefined : true };
            }
            if (value === "HOLIDAY") {
                return { ...prev, show_holiday: !prev.show_holiday };
            }
            return prev;
        });
    };

    const isChecked = (value: string) => {
        if (modeValues.includes(value)) return filter.modes.includes(value);
        if (arrangeTypeValues.includes(value)) return filter.arrange_types.includes(value);
        if (value === "CANCEL") return filter.is_cancel === true;
        if (value === "HOLIDAY") return !!filter.show_holiday;
        return false;
    };

    const handleReset = () => {
        setFilter(initialFilter);
        fetchGetSchedule?.({});
    };

    const handleSearch = () => {
        fetchGetSchedule?.({ ...filter });
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {options.map(opt => (
                <label
                    key={opt.value}
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        cursor: "pointer",
                    }}
                >
                    <Checkbox
                        checked={isChecked(opt.value)}
                        onChange={() => handleChange(opt.value)}
                    />
                    {opt.color && (
                        <span
                            style={{
                                width: 12,
                                height: 12,
                                borderRadius: 4,
                                backgroundColor: opt.color,
                                display: "inline-block",
                            }}
                        />
                    )}
                    <span style={{ fontSize: 14, lineHeight: "22px", color: "#374151" }}>{opt.label}</span>
                </label>
            ))}

            <div style={{ display: "flex", justifyContent: "end", gap: 12, marginTop: 24 }}>
                <div
                    onClick={!loading ? handleReset : undefined}
                    style={{
                        borderRadius: 6,
                        background: "#F9F9F9",
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: "14px",
                        color: "#252F4A",
                        padding: 12,
                        cursor: "pointer",
                    }}
                    
                >
                    {loading ? <Spin size="small" /> : "Reset"}
                </div>
                <div
                    onClick={!loading ? handleSearch : undefined}
                    style={{
                        borderRadius: 6,
                        background: "#FFB800",
                        color: "white",
                        fontSize: 13,
                        fontWeight: 500,
                        lineHeight: "14px",
                        padding: 12,
                        cursor: "pointer",
                    }}
                >
                    {loading ? <Spin size="small" /> : "Search"}
                    
                </div>
            </div>
        </div>
    );
};

export default ScheduleFilter;
